import { api } from './api';

export type SourceType = 'trends' | 'finance' | 'weather' | 'sports' | 'horoscope';
export type FeatureMode = 'auto' | 'semi' | 'off';

export interface GenerateRequest {
  source_type: SourceType;
  payload: Record<string, unknown>;
  framming?: string;
  status?: 'draft' | 'publish';
  wp_site?: string;
  dry_run?: boolean;
}

export interface WpSeoRef {
  wp: string | null;
  id: number | null;
  name: string | null;
}

export interface WpSeoPayload {
  wp_site: string | null;
  chapeu: string;
  title: string;
  linha_fina: string;
  excerpt: string;
  word_count: number;
  wordcount_ok: boolean;
  keywords: string[];
  image: { url: string | null; credits: string | null };
  editoria: WpSeoRef;
  autor: WpSeoRef;
  secao: WpSeoRef;
  meta: Record<string, string>;
  schema: {
    news_article: Record<string, unknown>;
    faq: Record<string, unknown> | null;
  };
}

export interface GenerateResult {
  source_type: SourceType;
  tema: string;
  title: string;
  excerpt: string;
  num_sources: number;
  framming: string;
  status: string;
  dry_run?: boolean;
  content_html?: string;
  wp_id?: number;
  wp_link?: string;
  scraped?: number;
  cover_image_url?: string | null;
  cover_source?: string | null;
  seo?: WpSeoPayload;
}

export interface FeatureConfig {
  mode: FeatureMode;
  publish_status: 'draft' | 'publish';
  cap_dia: number;
  wp_category_id: number | null;
  wp_site: string | null;
  image: boolean;
}

export interface SavePreviewRequest {
  source_type: SourceType;
  tema: string;
  editoria?: string;
  title: string;
  excerpt?: string;
  content_html: string;
  cover_image_url?: string | null;
  keywords?: string[];
  framming?: string;
  wp_site?: string;
  status?: 'draft' | 'publish';
}

export const contentService = {
  generate: (req: GenerateRequest): Promise<GenerateResult> =>
    api.post<GenerateResult>('/content/generate', req),
  savePreview: (req: SavePreviewRequest): Promise<GenerateResult> =>
    api.post<GenerateResult>('/content/save-preview', req),
  getFeatures: (): Promise<Record<SourceType, FeatureConfig>> =>
    api.get<Record<SourceType, FeatureConfig>>('/content/features'),
  setFeature: (vertical: SourceType, patch: Partial<FeatureConfig>): Promise<FeatureConfig> =>
    api.put<FeatureConfig>(`/content/features/${vertical}`, patch),
  horoscopeRun: (req: {
    signos?: string[];
    status?: 'draft' | 'publish';
    wp_site?: string;
    with_image?: boolean;
    dry_run?: boolean;
  }): Promise<HoroscopeRunResult> =>
    api.post<HoroscopeRunResult>('/content/horoscope/run', req),
  getHoroscopePrompt: (): Promise<{ template: string; default: string }> =>
    api.get('/content/horoscope/prompt'),
  setHoroscopePrompt: (template: string): Promise<{ template: string }> =>
    api.put('/content/horoscope/prompt', { template }),
};

export interface HoroscopeRunResult {
  date: string;
  status: string;
  count: number;
  ok: number;
  results: {
    signo: string;
    ok: boolean;
    title?: string;
    wp_link?: string;
    dry_run?: boolean;
    error?: string;
  }[];
}
